"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheKingsWardrobeAbilityHandler = exports.TheKingsWardrobeActorAbilityFactory = exports.TheKingsWardrobeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class TheKingsWardrobeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TheKingsWardrobe;
        this.__typeName = "TheKingsWardrobe";
    }
}
exports.TheKingsWardrobeAbilityArgs = TheKingsWardrobeAbilityArgs;
let TheKingsWardrobeActorAbilityFactory = class TheKingsWardrobeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TheKingsWardrobe", "Self", 0);
    }
};
TheKingsWardrobeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TheKingsWardrobe")
], TheKingsWardrobeActorAbilityFactory);
exports.TheKingsWardrobeActorAbilityFactory = TheKingsWardrobeActorAbilityFactory;
let TheKingsWardrobeAbilityHandler = class TheKingsWardrobeAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            effect: new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.AllDamageResistance, Math.round(__1.BASE_LEVEL_ADR * container.getLevel(actorId))),
            duration: Duration_1.Duration.Permanent,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
TheKingsWardrobeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TheKingsWardrobe)
], TheKingsWardrobeAbilityHandler);
exports.TheKingsWardrobeAbilityHandler = TheKingsWardrobeAbilityHandler;
